/**
 * html-to-image não rejeita com `Error`: quando um recurso embutido não carrega,
 * ele rejeita com o próprio `Event` de erro da imagem, que não tem `message`.
 * Ler `err.message` direto trocava qualquer falha pelo mesmo texto genérico
 * ("Falha ao gerar comprovante"), e aí não havia como saber em que etapa a
 * captura morreu.
 */
export const describeCaptureError = (err: unknown): string => {
  if (err instanceof Error && err.message) return err.message;

  if (typeof Event !== 'undefined' && err instanceof Event) {
    const tag = (err.target as Element | null)?.tagName?.toLowerCase();

    return tag === 'img'
      ? 'Não foi possível carregar uma imagem do comprovante. Recarregue a página e tente novamente.'
      : `Falha ao renderizar o comprovante (${err.type}). Recarregue a página e tente novamente.`;
  }

  return 'Falha ao gerar comprovante';
};
